<!--  -->
<template>
  <div class="time_pushbox">
    <div class="strate_box">
      <div>定时名称：</div>
      <el-input v-model="sendobj.pushtimevalue" style="width:300px" placeholder="定时名称" />
    </div>
    <div class="strate_box">
      <div>选择平台：</div>
      <el-select v-model="sendobj.promlate" placeholder="请选择" @change="chooseplatform">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div>
    <div v-if="sendobj.promlate!=null" class="strate_box">
      <div>选择标签组：</div>
      <el-select v-model="sendobj.labelvalue" multiple :disabled="optionsr.length===0" placeholder="请选择" @visible-change="biaoqianzu">
        <el-option
          v-for="item in optionsr"
          :key="item.id"
          :label="item.tag_group_name"
          :value="item.id"
        />
      </el-select>
    </div>
    <div v-if="sendobj.promlate!=null" class="strate_box">
      <div>*多标签组合为并且的关系</div>
    </div>
    <div class="strate_box">
      <div>关注时间：</div>
      <div>
        <el-select v-model="subscribe_time_type" placeholder="请选择">
          <el-option
            v-for="item in optionsrr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div v-if="subscribe_time_type === 7" style="margin-left:10px">
        <el-date-picker
          v-model="subscribetime"
          style="width:400px"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm"
          :default-time="['00:00:00', '23:59:59']"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          @change="timechanger"
        />
      </div>
    </div>
    <div class="strate_box">
      <div>互动时间：</div>
      <div>
        <el-select v-model="interaction_time_type" placeholder="请选择">
          <el-option
            v-for="item in optionsrr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div v-if="interaction_time_type === 7" style="margin-left:10px">
        <el-date-picker
          v-model="interactiontime"
          style="width:400px"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm"
          :default-time="['00:00:00', '23:59:59']"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          @change="timechangerall"
        />
      </div>
    </div>
    <div class="strate_box">
      <div>付费情况：</div>
      <div>
        <el-radio-group v-model="consumption">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">未付费</el-radio>
          <el-radio :label="2">已付费</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="strate_box">
      <div>发送时间：</div>
      <el-date-picker
        v-model="sendobj.sendtime"
        :picker-options="pickerOptions"
        :clearable="false"
        type="datetime"
        placeholder="选择日期时间"
        format="yyyy-MM-dd HH:mm"
        value-format="yyyy-MM-dd HH:mm"
      />
    </div>
    <div class="strate_box">
      <div>消息类型：</div>
      <div>
        <el-radio-group v-model="sendobj.radio" @change="customerclick">
          <el-radio :label="1">客服消息</el-radio>
          <el-radio :label="2">模板消息</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div v-if="sendobj.promlate!=null">
      <div v-if="sendobj.radio === 1">
        <div class="strate_box">
          <div>
            选择的消息：
          </div>
          <div>
            {{ messagename }}
          </div>
        </div>
        <el-input v-model="kefuquery.title" clearable style="width:200px;" placeholder="请输入标题" />
        <el-input v-model="kefuquery.customer_message_no" clearable style="width:200px;margin:0 20px" placeholder="请输入编号" />
        <el-select v-model="kefuquery.msg_type" placeholder="请选择">
          <el-option
            v-for="itemr in selectoptionse"
            :key="itemr.key"
            :label="itemr.value"
            :value="itemr.key"
          />
        </el-select>
        <el-button style="margin-left:10px" type="primary" icon="el-icon-search" @click="getacclist()">搜索</el-button>
        <el-button type="primary" @click="rechar">重置</el-button>
        <!-- <el-button v-if="kefuid!==null" type="primary" @click="timingpreview">预览</el-button> -->
        <el-table
          ref="table"
          :key="refreshKey"
          :data="publicAdvelist"
          style="width: 50%"
        >
          <el-table-column
            label="选项"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <input
                v-model="scope.row.checkboxFlag"
                type="checkbox"
                @click="handleChangeSelectone(scope.$index, scope.row)"
              >
              {{ scope.row.$index }}
            </template>
          </el-table-column>
          <el-table-column
            prop="customer_message_no"
            label="编号"
            align="center"
          />
          <el-table-column
            prop="title"
            label="标题"
            align="center"
          />
          <el-table-column
            prop="msg_type_str"
            label="类型"
            align="center"
          />
          <el-table-column
            prop="platform_name"
            label="所属平台"
            align="center"
          />
          <el-table-column
            :key="refreshKey"
            label="操作"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="primary" @click="timingpreview(scope.row,1)">预览</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination-right
          :total="kefutotal"
          :current-page="kefuquery.page"
          @size-change="fetchPageSizeone"
          @current-change="fetchCurrentPageone"
        />
      </div>
    </div>
    <div v-if="sendobj.promlate!=null">
      <div v-if="sendobj.radio === 2">
        <div class="strate_box">
          <div>
            选择的消息：
          </div>
          <div>
            {{ templatename }}
          </div>
        </div>
        <el-table
          :key="refreshKeyr"
          :data="templatedatalist"
          style="width: 50%"
        >
          <el-table-column

            label="选项"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <input
                v-model="scope.row.checkboxFlag"
                type="checkbox"
                @click="handleChangeSelectonewe(scope.$index, scope.row)"
              >
              {{ scope.row.$index }}
            </template>
          </el-table-column>
          <el-table-column
            prop="template_message_admin_no"
            label="编号"
            align="center"
          />
          <el-table-column
            prop="title"
            label="标题"
            align="center"
          />
          <el-table-column
            prop="platform_name"
            label="所属平台"
            align="center"
          />
          <el-table-column
            :key="refreshKeyr"
            label="操作"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="primary" @click="timingpreview(scope.row,2)">预览</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination-right
          :total="templatetotalrwe"
          :current-page="mobanquery.page"
          @size-change="temfetchPageSizeone"
          @current-change="temfetchCurrentPageone"
        />
      </div>
    </div>
    <div v-if="sendobj.promlate!=null" class="strate_box">
      <div>选择公众号：</div>
      <div>
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.id,index)"
        >
          {{ itemr.name }}
        </el-tag>
        <el-tag @click="chooseaccout">选择公众号</el-tag>
      </div>
    </div>

    <div>
      <el-button type="primary" size="small" :disabled="savedisabled" @click="btnclick">提交</el-button>
      <el-button type="primary" size="small" @click="gobackone">返回</el-button>
    </div>

    <div>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        :destroy-on-close="true"
        width="50%"
      >
        <ChooseaccountDialog ref="chhoseaccout" @closedialog="closedialog" @closedialogone="closedialogone" />
      </el-dialog>
      <el-dialog
        title="预览"
        :visible.sync="dialogVisiblepriwe"
        width="30%"
      >
        <PreviewDialog ref="timepreview" />
      </el-dialog>
      <el-dialog
        title="绑定公众号失败列表"
        :visible.sync="erroraccount"
        width="60%"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <errorlist ref="errorlistview" @emptyaccount="emptyaccount" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { strategyPlatform, customermessagelist, customercreatlist, templateadminlist, adminlist, creattimepush } from '@/api/sourceMaterial.js'
import ChooseaccountDialog from './components/ChooseaccountDialog.vue'
import PreviewDialog from './components/PreviewDialog'
import PaginationRight from '@/components/PaginationRight/index.vue'
import errorlist from '../redEnvelopeActivity/components/errorlist.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    ChooseaccountDialog,
    PaginationRight,
    PreviewDialog,
    errorlist
  },
  mixins: [convertToHump],
  data() {
    return {
      interaction_time_type: 0,
      interactiontime: [],
      interaction_time_from: '',
      interaction_time_to: '',
      subscribetime: [],
      subscribe_time_from: '',
      subscribe_time_to: '',
      subscribe_time_type: 0,
      consumption: 0,
      optionsrr: [{
        value: 0,
        label: '不限'
      }, {
        value: 8,
        label: '24小时内'
      }, {
        value: 1,
        label: '2天(48小时)以内'
      }, {
        value: 2,
        label: '2天(48小时)前'
      }, {
        value: 3,
        label: '2至7天'
      }, {
        value: 4,
        label: '7天内'
      }, {
        value: 5,
        label: '7天前'
      }, {
        value: 6,
        label: '今天前'
      },
      {
        value: 7,
        label: '自定义'
      }],
      erroraccount: false,
      options: [], // 平台
      sendobj: {
        pushtimevalue: null, // 定时名称
        promlate: null, // 平台id
        labelvalue: [], // 选择标签
        sendtime: null, // 发送时间
        radio: 1, // 消息类型
        relationId: null// 消息编号id、模板消息或者客服消息
      },
      promlateType: 1, // 判断是不是第一次开启下拉框
      dialogVisible: false,
      dialogVisiblepriwe: false,
      optionsr: [],
      arrs: [], // 选择公众号数组
      arrsw: [], // 选择公众号数组 id集合

      publicAdvelist: [], // 客服消息数组
      refreshKey: 0, // 客服消息key
      selectoptionse: [],
      kefutotal: null,
      kefuid: null, // 客服id
      messagename: null,
      kefuquery: {
        page: 1,
        pageSize: 10,
        title: null,
        msg_type: null,
        customer_message_no: null,
        platform_id: null
      },

      templatename: null, // 模板名称
      refreshKeyr: 0,
      templatedatalist: [],
      mobanid: null,
      templatetotalrwe: null,
      mobanquery: {
        page: 1,
        pageSize: 10,
        platform_id: null
      },
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      savedisabled: false,
      failsarr: [],
      allarr: []
    }
  },
  created() {
    this.getstrategyplatformlist()
    this.typelist()
    // this.getacclist()
    // this.gettempalte()
    this.optionsr.push({
      id: 0,
      tag_group_name: '全部'
    })
    const obj = {}
    obj.name = 'yang'
    window.localStorage.setItem('user', JSON.stringify(obj))
    const list = JSON.parse(localStorage.getItem('user'))
    list.id = 2
    console.log(list)
    localStorage.setItem('user', JSON.stringify(list))
  },
  mounted() {

  },
  methods: {
    timechanger(val) {
      this.subscribe_time_from = val[0]
      this.subscribe_time_to = val[1]
      console.log('val', val)
    },
    timechangerall(val) {
      this.interaction_time_from = val[0]
      this.interaction_time_to = val[1]
      console.log('val', val)
    },
    // 获取策略平台
    async getstrategyplatformlist() {
      const data = await strategyPlatform()
      this.options = data.data.list
    },
    // 获取筛选类数组
    async typelist() {
      const data = await customermessagelist()
      this.selectoptionse = data.data.list
    },
    // 获取客服消息列表
    async getacclist() {
      const data = await customercreatlist(this.kefuquery)
      console.log(data, '=================')
      this.publicAdvelist = data.data.list
      this.publicAdvelist.forEach(item => {
        item.checkboxFlag = false
        if (item.customer_message_no === this.kefuid) {
          item.checkboxFlag = true
        }
      })
      this.kefutotal = data.data.total
      console.log(data)
    },
    // 获取模板消息列表
    async gettempalte() {
      const data = await templateadminlist(this.mobanquery)

      this.templatedatalist = data.data.list
      this.templatedatalist.forEach(item => {
        item.checkboxFlag = false
        if (item.template_message_admin_no === this.mobanid) {
          item.checkboxFlag = true
        }
      })
      this.templatetotalrwe = data.data.total
    },
    fetchPageSizeone(e) {
      this.kefuquery.pageSize = e
      this.getacclist()
    },
    fetchCurrentPageone(e) {
      this.kefuquery.page = e
      this.getacclist()
    },
    temfetchPageSizeone(e) {
      this.mobanquery.pageSize = e
      this.gettempalte()
    },
    temfetchCurrentPageone(e) {
      this.mobanquery.page = e
      this.gettempalte()
    },
    // 客服消息单选
    handleChangeSelectone(index) {
      if (!this.publicAdvelist[index].checkboxFlag) {
        this.messagename = this.publicAdvelist[index].title
        this.kefuid = this.publicAdvelist[index].customer_message_no
        this.sendobj.relationId = this.publicAdvelist[index].customer_message_no
      } else {
        // this.selectData = null
      }
      this.publicAdvelist.forEach(item => {
        item.checkboxFlag = false
      })
      this.publicAdvelist[index].checkboxFlag = true
      this.refreshKey = Math.random()
    },
    // 模板消息单选
    handleChangeSelectonewe(index) {
      if (!this.templatedatalist[index].checkboxFlag) {
        this.templatename = this.templatedatalist[index].title
        this.mobanid = this.templatedatalist[index].template_message_admin_no
        this.sendobj.relationId = this.templatedatalist[index].template_message_admin_no
      } else {
        // this.selectData = null
      }
      this.templatedatalist.forEach(item => {
        item.checkboxFlag = false
      })
      this.templatedatalist[index].checkboxFlag = true
      this.refreshKeyr = Math.random()
    },
    // 客服消息重置
    rechar() {
      this.kefuquery.title = null
      this.kefuquery.customer_message_no = null
      this.kefuquery.msg_type = null
      this.kefuquery.page = 1
      this.kefuquery.pageSize = 10
      // this.kefuquery = {
      //   title: null,
      //   customer_message_no: null,
      //   msg_type: null,
      //   page: 1,
      //   pageSize: 10
      // }
      this.getacclist()
    },
    chooseaccout() {
      if (this.sendobj.promlate === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.sendobj.radio === 1) {
        if (this.messagename === null) {
          this.$message.error('请选择客服消息')
          return
        }
      }
      if (this.sendobj.radio === 2) {
        if (this.templatename === null) {
          this.$message.error('请选择模板消息')
          return
        }
      }
      this.dialogVisible = true
      console.log('this.arrs', this.arrs)
      // eslint-disable-next-line eqeqeq
      if (this.sendobj.promlate == 99) {
        if (this.sendobj.radio === 1) {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.chhoseaccout.sendrs(this.sendobj.promlate, this.arrs, this.kefuid, 1, 1)
          }, 100)
        } else {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.chhoseaccout.sendrs(this.sendobj.promlate, this.arrs, this.mobanid, 2, 1)
          }, 100)
        }
      } else {
        if (this.sendobj.radio === 1) {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.chhoseaccout.sendrs(this.sendobj.promlate, this.arrs, this.kefuid, 1, 1)
          }, 100)
        } else {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.chhoseaccout.sendrs(this.sendobj.promlate, this.arrs, this.mobanid, 2, 1)
          }, 100)
        }
      }
    },
    // 提交按钮
    async btnclick() {
      this.arrsw = this.arrs.map(item => {
        return item.id
      })
      if (this.sendobj.pushtimevalue === null) {
        this.$message.error('请填写定时名称')
        return
      }
      if (this.sendobj.promlate === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.subscribe_time_type === null) {
        this.$message.error('请选择关注时间')
        return
      }
      if (this.interaction_time_type === null) {
        this.$message.error('请选择互动时间')
        return
      }
      if (this.subscribe_time_type === 7) {
        if (this.subscribetime.length === 0) {
          this.$message.error('请选择自定义时间范围')
          return
        }
      }
      if (this.interaction_time_type === 7) {
        if (this.interactiontime.length === 0) {
          this.$message.error('请选择自定义时间范围')
          return
        }
      }
      if (this.sendobj.labelvalue.length === 0) {
        this.$message.error('请选择标签组')
        return
      }
      if (this.sendobj.sendtime === null) {
        this.$message.error('请选择发送时间')
        return
      }
      if (this.arrsw.length === 0) {
        this.$message.error('请选择公众号')
        return
      }
      if (this.sendobj.relationId === null) {
        this.$message.error('请选择消息')
        return
      }
      //   sendobj: {
      //   pushtimevalue: null, // 定时名称
      //   promlate: null, // 平台id
      //   labelvalue: null, // 选择标签
      //   sendtime: null, // 发送时间
      //   radio: 1, // 消息类型
      //   relationId: null// 消息编号id、模板消息或者客服消息
      // },
      // console.log(this.sendobj, this.arrs, this.arrsw)
      const parms = {}
      if (this.subscribe_time_type === 7) {
        parms.subscribe_time_type = this.subscribe_time_type
        parms.subscribe_time_from = this.subscribe_time_from
        parms.subscribe_time_to = this.subscribe_time_to
        parms.consumption = this.consumption
      } else {
        parms.subscribe_time_type = this.subscribe_time_type
        parms.consumption = this.consumption
      }
      const huparms = {}
      if (this.interaction_time_type === 7) {
        huparms.interaction_time_type = this.interaction_time_type
        huparms.interaction_time_from = this.interaction_time_from
        huparms.interaction_time_to = this.interaction_time_to
      } else {
        huparms.interaction_time_type = this.interaction_time_type
      }
      try {
        this.savedisabled = true
        const data = await creattimepush({
          relation_id: this.sendobj.relationId,
          send_time: this.sendobj.sendtime,
          app_ids: this.arrsw,
          relation_type: this.sendobj.radio,
          tag_group_ids: this.sendobj.labelvalue,
          platform_id: this.sendobj.promlate,
          task_name: this.sendobj.pushtimevalue,
          ...parms,
          ...huparms
        })
        console.log('data', data)
        if (data.code === 204) {
          console.log('绑定有问题', data.data.fails)
          this.savedisabled = false
          this.erroraccount = true
          this.failsarr = []
          this.failsarr = data.data.fails
          this.$nextTick(() => { // 请求成功之后，在这里执行
            this.$refs.errorlistview.send(data.data.fails, 1)
          })
        }
        if (data.data === null) {
          this.$message({
            message: `${data.message}`,
            type: 'success'
          })
          this.$router.push({ path: '/timedPushlist/index' })
          this.savedisabled = false
        }
      } catch (e) {
        console.log('发生异常:' + e)
        this.savedisabled = false
      }
    },
    emptyaccount() {
      this.erroraccount = false
      console.log(this.arrs)
      console.log(this.failsarr)
      this.allarr = []
      // eslint-disable-next-line eqeqeq
      this.allarr = this.arrs.filter(x => this.failsarr.every(y => y.app_id != x.id))
      console.log('this.allarr', this.allarr)
      this.arrs = this.allarr
      this.dialogVisible = true
      console.log('this.arrs', this.arrs)
      // eslint-disable-next-line eqeqeq
      if (this.sendobj.promlate == 99) {
        if (this.sendobj.radio === 1) {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.chhoseaccout.sendrs(this.sendobj.promlate, this.allarr, this.kefuid, 1, 1)
          }, 100)
        } else {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.chhoseaccout.sendrs(this.sendobj.promlate, this.allarr, this.mobanid, 2, 1)
          }, 100)
        }
      } else {
        if (this.sendobj.radio === 1) {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.chhoseaccout.sendrs(this.sendobj.promlate, this.allarr, this.kefuid, 1, 1)
          }, 100)
        } else {
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.chhoseaccout.sendrs(this.sendobj.promlate, this.allarr, this.mobanid, 2, 1)
          }, 100)
        }
      }
    },
    // 选择完 回调
    closedialog(arr) {
      this.arrs = arr
      this.dialogVisible = false
      console.log('arr', arr)
    },
    closedialogone(arr) {
      this.arrs = arr
    },
    rightclick(id, index) {
      console.log('删除了')
      this.arrs.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.set(id)
      }, 100)

      console.log(id, index)
    },
    customerclick(val) {
      if (val === 1) {
        this.sendobj.relationId = this.kefuid
        console.log('客服', this.kefuid)
      } else {
        this.sendobj.relationId = this.mobanid
        console.log('模板', this.mobanid)
      }
    },
    chooseplatform(val) {
      // eslint-disable-next-line eqeqeq
      // if (this.promlateType !== 1) {
      //   this.$confirm('您确定要变更平台吗？变更后选择的公众号将会清空, 是否继续?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     console.log('chooseplatform', val)
      //     this.kefuquery.platform_id = val
      //     this.mobanquery.platform_id = val
      //     this.arrs = []
      //     this.getacclist()
      //     this.gettempalte()
      //     this.getchooselist(val)
      //   }).catch(() => {

      //   })
      // } else {
      //   this.kefuquery.platform_id = val
      //   this.mobanquery.platform_id = val
      //   this.arrs = []
      //   this.getacclist()
      //   this.gettempalte()
      //   this.getchooselist(val)
      //   this.promlateType = 2
      //   console.log('777')
      // }
      this.kefuquery.page = 1
      this.mobanquery.page = 1
      this.kefuquery.platform_id = val
      this.mobanquery.platform_id = val
      this.arrs = []
      this.getacclist()
      this.gettempalte()
      this.getchooselist(val)
      this.promlateType = 2
    },
    async getchooselist(id) {
      const data = await adminlist({
        page: 1,
        page_size: 50,
        platform_id: id
      })
      this.optionsr = []
      // this.sendobj.labelvalue = null
      this.optionsr = data.data.list
      this.optionsr.unshift({
        id: 0,
        tag_group_name: '全部'
      })
      this.sendobj.labelvalue = []
      // 清空上次选消息的参数
      this.sendobj.relationId = null
      this.kefuid = null
      this.mobanid = null
      this.messagename = null
      this.templatename = null
      console.log('datalist阿', data.data.list)
    },
    biaoqianzu() {
      console.log('this.sendobj.labelvalue', this.sendobj.labelvalue)
      for (let i = 0; i < this.sendobj.labelvalue.length; i++) {
        if (this.sendobj.labelvalue[i] === 0) {
          this.sendobj.labelvalue = [0]
        }
      }
    },
    // 客服预览
    timingpreview(val, id) {
      // val = this.convertToHump(val)
      this.dialogVisiblepriwe = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(val, id)
      }, 100)
    },
    gobackone() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.time_pushbox{
  padding: 20px;
}
.strate_box{
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  div{
    flex-shrink: 0;
    font-size: 14px;
    color: #606266;
  }
   span{
      margin-left: 10px;
   }
}
// ::v-deep .el-dialog__header{
// border-bottom: 1px solid blue;
// }
</style>
